import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { PlatformService, PreferencesService, UserPreferences } from '@tdwb/core';

@Component({
  selector: 'td-wb-responsive-option',
  templateUrl: 'responsive-option.component.html',
  styleUrls: ['responsive-option.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ResponsiveOptionComponent implements OnInit, OnDestroy {

  isSmallScreen: boolean;
  usingResponsive: boolean;

  private screenSizeChangeSubscription: Subscription;

  constructor(private preferencesService: PreferencesService,
              private platformService: PlatformService,
              private changeDetectorRef: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.usingResponsive = this.preferencesService.getPreloadedUserPreference<boolean>('USING_RESPONSIVE');
    this.isSmallScreen = this.platformService.isMobileOrTabletPortraitView();
    this.screenSizeChangeSubscription = this.platformService.onScreenSizeChange.subscribe((): void => {
      this.isSmallScreen = this.platformService.isMobileOrTabletPortraitView();
      this.changeDetectorRef.markForCheck();
    });
  }

  ngOnDestroy(): void {
    this.screenSizeChangeSubscription?.unsubscribe();
  }

  toggle(): false {
    this.preferencesService.toggleResponsivePreference().subscribe((userPreferences: UserPreferences): void => {
      this.usingResponsive = userPreferences.USING_RESPONSIVE as boolean;
      this.changeDetectorRef.markForCheck();
    });
    return false;
  }
}
